// Native
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  check = 'icons/check.svg';
  help = 'icons/help.svg';
  logout = 'icons/logout.svg';

  attr: any = {
    menu: {
      default: { width: 16, height: 16 }
    },
    input: {
      default: { width: 16, height: 16 }
    },
    default: {
      check: {width: 14, height: 14},
    },
  };

  constructor() {}
}

